import './About.scss';

import { type FC, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import * as Core from 'components/core';
import ColorBar from 'components/ColorBar';
import Pdf from 'components/vectors/Pdf';
import WWW from 'components/vectors/WWW';

interface Props {
  family: {
    name: string;
    description: string | null;
    micrositeUrl: string | null;
    specimenDocumentUrl: string | null;
    conceptFont: boolean;
  };
}

export const About: FC<Props> = (props) => {
  const { family } = props;

  const { t } = useTranslation();

  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = useCallback(() => {
    setShowDetails((value) => !value);
  }, []);

  return (
    <ColorBar>
      <div className="FamiliesAbout content-wrapper">
        <h2>{t('family.about')}</h2>

        <Core.Markdown>{family.description}</Core.Markdown>

        {family.micrositeUrl && (
          <div>
            <a
              className="FamiliesAbout-microsite-link"
              href={family.micrositeUrl}
            >
              <div className="FamiliesAbout-microsite-link-wrapper">
                <WWW />
                <div className="FamiliesAbout-microsite-link-text">
                  {t('family.microsite', {
                    familyName: family.name,
                  })}
                </div>
              </div>
            </a>
          </div>
        )}

        {family.specimenDocumentUrl && (
          <div>
            <a
              className="FamiliesAbout-specimen-link"
              href={family.specimenDocumentUrl}
            >
              <div className="FamiliesAbout-specimen-link-wrapper">
                <Pdf />
                <div className="FamiliesAbout-specimen-link-text">
                  {t('family.downloadSpecimen')}
                </div>
              </div>
            </a>
          </div>
        )}

        {family.conceptFont && (
          <>
            <p className="FamiliesAbout-conceptsNote">
              {t('family.concepts.description', { familyName: family.name })}

              <button
                className="FamiliesAbout-readMore"
                type="button"
                onClick={toggleDetails}
              >
                {showDetails
                  ? t('family.concepts.readLess')
                  : t('family.concepts.readMore')}
              </button>
            </p>

            {showDetails && (
              <>
                <p>{t('family.concepts.additionalDetails')}</p>
              </>
            )}
          </>
        )}
      </div>
    </ColorBar>
  );
};

export default About;
